export enum MyClockNotificationsEnum {
  None = 'none',
  OnlyAutomatic = 'only_automatic',
  All = 'all',
}

export const MyClockNotificationsEnumLabels: Record<MyClockNotificationsEnum, string> = {
  [MyClockNotificationsEnum.None]: 'Ninguna',
  [MyClockNotificationsEnum.OnlyAutomatic]: 'Solo fichajes automáticos',
  [MyClockNotificationsEnum.All]: 'Todas',
};

export const MyClockNotificationsEnumDescriptions: Record<MyClockNotificationsEnum, string> = {
  [MyClockNotificationsEnum.None]: 'No recibirás ninguna notificación',
  [MyClockNotificationsEnum.OnlyAutomatic]:
    'Recibirás notificaciones cuando se te acabe la pausa y se realice un fichaje de salida automático',
  [MyClockNotificationsEnum.All]: 'Recibirás todas tus notificaciones de fichajes',
};
